import SideBar from "../components/SideBar"
import {useState, useEffect} from 'react'
import{useSelector,useDispatch} from "react-redux"
import {useNavigate} from "react-router-dom"
import { addMovie, fetchDetailMovie, fetchGenre, fetchMovie } from "../store/actions"
import Swal from "sweetalert2"

export default function AddMoviePage(){
    const dispatch= useDispatch()
    const navigate= useNavigate()
    const{genres} = useSelector((state)=>state.genre)

useEffect(()=>{
    dispatch(fetchGenre())
},[])

const[addInput,setAddInput]= useState({
    title:"",
    synopsis: "",
    trailerUrl: "",
    imgUrl:"",
    rating: "",
    genreId: "",
    name: "",
    profilePict: ""
})
const inputAdd= (e)=>{
    const {name,value}= e.target
    setAddInput({
        ...addInput,
        [name]: value
    })

}

    const addHandler= (e)=>{
        e.preventDefault();
       dispatch(addMovie(addInput))
       .then((response)=>{
        return response.json()
    })
    .then((data)=>{
        if(data.message){
            Swal.fire({
                icon:'error',
                title: data.message
               })
            navigate('/add')
        }else{
            Swal.fire({
                icon:'success',
                title: `Success add movie`
               })
            dispatch(fetchMovie())
            navigate('/')
        }
    })
    .catch((error)=>{
        console.log(error);
    })

    }
    return(
        <div>
        <SideBar/>
   <form onSubmit={addHandler}>
<div className="justify-center items-center pt-20 flex flex-col" style={{height:"100vh"}}>
<div className="text-center rounded-lg pt-20" style={{width: "1000px", height: "800px"}}>
   <p className="font-bold" style={{fontSize: "15pt"}}>Add Movie</p>
   <div className="pt-5">
   <label>Title</label><br/>
   <input value={addInput.title} name="title" onChange={inputAdd}  type="text" style={{width: "300px", height:"35px"}} placeholder="Title" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
    <label>Synopsis</label><br/>
   <input value={addInput.synopsis} name="synopsis" onChange={inputAdd} type="text" style={{width: "300px", height:"35px"}} placeholder="Synopsis"  className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Trailer Url</label><br/>
   <input value={addInput.trailerUrl} name="trailerUrl" onChange={inputAdd}  type="text" style={{width: "300px", height:"35px"}} placeholder="Trailer Url" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Image Url</label><br/>
   <input value={addInput.imgUrl} name="imgUrl" onChange={inputAdd}  type="text" style={{width: "300px", height:"35px"}} placeholder="Image Url" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Rating</label><br/>
   <input value={addInput.rating} name="rating" onChange={inputAdd}  type="number" style={{width: "300px", height:"35px"}} placeholder="Rating" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Genre</label><br/>
    <select name="genreId" onChange={inputAdd}>
        <option value="" selected disabled>CHOOSE ONE</option>
        {genres.map((genre)=>
        <option key={genre.id} value={genre.id} onChange={inputAdd}>{genre.name}</option>
        )}
    </select>
   </div>
   <div className="pt-5">
    <h1>MOVIE CAST</h1>
   </div>
   <div className="pt-5">
   <label>Name</label><br/>
   <input value={addInput.name} name="name" onChange={inputAdd}  type="text" style={{width: "300px", height:"35px"}} placeholder="Name" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5">
   <label>Profile Pict</label><br/>
   <input value={addInput.profilePict} name="profilePict" onChange={inputAdd}  type="text" style={{width: "300px", height:"35px"}} placeholder="Profile Picture" className="border-2 rounded-md pl-2"/>
   </div>
   <div className="pt-5 pb-10">
   <button className="bg-purple-400 h-8 rounded-lg hover:bg-purple-300"  style={{width: "300px", height:"35px"}}>Submit</button>
   </div>
</div>
</div>
</form>
</div>
    )
}